<!-- Concat.vue -->
<template>
	<div class="main-content" v-if="storeInfo.store_baozh">
		<flex-line :is-link="true" :show-border="true" @click.native="changeTranslateState()">
			<span>保障</span>
		</flex-line>
		</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import flexLine from '../../../flexLine'
export default {
  data () {
    return {}
  },

components:{flexLine},
  computed: {
    ...mapState({
      storeInfo: state => state.goodsdetail.storeInfo,
    })
  },

  watch: {},

  mounted () {
    this.$nextTick(() => {})
  },

  created () {},

  methods: {
    ...mapMutations({
      saveTranslateState: 'saveTranslateState',
    }),
    
    changeTranslateState () {
      this.saveTranslateState(true)
    },
  }
}
</script>

<style lang="scss" scoped>

	.main-content{padding:0 $pageSpace;background-color: #fff;}
</style>
